import { connect } from 'react-redux';
import BaseCollection from './BaseCollection';
import { showCollectionModal } from '../../redux/actions/modals'
import collections from '../../api/collections';
class CollectionPerformance extends BaseCollection {
  fnRowClick = collections.getBankingPerformanceDetail;
  fnRefresh = collections.getBankingPerformance;
  fnGetSummaryPdf = collections.getPerformanceSummaryPdf;
  fnGetVariancePdf = collections.getPerformanceVariancePdf;
  fnGetExport = collections.getBankingPerformanceExport;

  reportName = "Net Income PDF";
  reportFileName = "Collection Net Income";
  exportFileName = "Collection Net Income Export CSV"
  modalTitle = "Collection Week Net Income";
}

const mapStateToProps = state => {
	return {
    installationsFilters: state.installationsFilters,
    collectionsFilters: state.collectionsFilters,
  };
};

export default connect(mapStateToProps, { showCollectionModal })(CollectionPerformance);